module.exports = __webpack_public_path__ + "3f62a777.svg";